import { gql } from "@apollo/client";

export const USER_STATUS = gql`
  query userStatusByEmail($data: EmailInput!) {
    userStatusByEmail(
      data: $data
    ) {
      emailExistAuth0,
      emailExistEV,
      profile {
        isEmailConfirmed,
        location,
        primaryEmail,
      },
      messages
    }
  }`;
